<template>
  <div class="MallIndex">
    <!-- 1. 首屏 Banner / Hero 区域 (支持骨架屏、真实轮播与优雅兜底) -->
    <div class="hero-banner-section">
      <!-- 态 1：骨架屏加载态 (流光微动，高度精准 440px，心理暗示正在加载，消除假文案闪现) -->
      <div v-if="bannerLoading" class="banner-skeleton">
        <div class="skeleton-shimmer"></div>
        <div class="skeleton-badges">
          <span class="skeleton-badge-pill"></span>
        </div>
        <div class="skeleton-text-lines">
          <div class="skeleton-line title"></div>
          <div class="skeleton-line desc"></div>
        </div>
      </div>

      <!-- 态 2：真实轮播图 (带 0.35s 丝滑淡入) -->
      <div v-else-if="bannerList && bannerList.length > 0" class="carousel-container fade-in">
        <el-carousel height="440px" :interval="5000" arrow="hover">
          <el-carousel-item v-for="(item, index) in bannerList" :key="index">
            <img class="banner-img" :src="item.url" alt="Banner" />
          </el-carousel-item>
        </el-carousel>
      </div>

      <!-- 态 3：无轮播图时的深蓝企业 Hero 持久兜底 (接口确认无数据才展示) -->
      <div v-else class="hero-default-card fade-in">
        <div class="hero-pattern-overlay"></div>
        <div class="hero-glow-sphere"></div>
        <div class="hero-content">
          <div class="hero-badge">
            <span class="badge-dot"></span>
            <span>2026 年度企业数字化采购框架协议</span>
          </div>
          <h1 class="hero-heading">一站式企业数字化采购平台</h1>
          <p class="hero-subtext">
            正品官方直供 · 框架协议底价 · 含 13% 增值税专票 · 企业月结对账零门槛
          </p>
          <div class="hero-actions">
            <button class="hero-btn primary" @click="selectType(1)" type="button">
              <span>浏览协议采购目录</span>
              <i class="el-icon-right"></i>
            </button>
            <button class="hero-btn outline" @click="navTo('/mall/regularPurchaseList')" type="button">
              <i class="el-icon-document"></i>
              <span>常购清单</span>
            </button>
          </div>
        </div>
      </div>
    </div>

    <!-- 2. 首页公告栏 (常驻呈现：优先展示接口机构公告，无接口公告时展示统一平台服务公告) -->
    <div class="notice-bar-container">
      <div class="notice-inner">
        <div class="notice-tag">
          <i class="el-icon-bell bell-icon"></i>
          <span>系统公告</span>
        </div>
        <div class="notice-content" :title="displayNotice">
          {{ displayNotice }}
        </div>
      </div>
    </div>

    <!-- 3. 核心采购专区：产品推荐 (标准 5 列纯白微边框卡片网格) -->
    <section class="product-showcase-section" id="product-showcase">
      <div class="section-header-bar">
        <div class="title-left">
          <span class="title-accent-bar"></span>
          <h2 class="section-title">产品推荐</h2>
          <span class="section-subtitle">协议直供现货 · 支持企业批量调货</span>
        </div>
        <a class="view-all-link" @click="selectType(1)">
          <span>查看全部商品</span>
          <i class="el-icon-arrow-right"></i>
        </a>
      </div>

      <!-- 5 列卡片网格 (完全绑定真实 goodsList 字段) -->
      <ul class="goods-grid">
        <GoodsItem
          v-for="(item, index) in goodsList"
          :key="index"
          :id="item.id"
          :img="
            item.rguiigpafo0pe0my && item.rguiigpafo0pe0my.length > 0
              ? item.rguiigpafo0pe0my[0].url
              : ''
          "
          :name="item.avdrlfwlhg7kywxn"
          :price="item.f93blbqlvdtdt65v"
          :section="item.dzornqdwofgytboq"
          :supplier-name="
            item.cijhopahvvolyisa && item.cijhopahvvolyisa.length > 0
              ? item.cijhopahvvolyisa[0].value
              : ''
          "
          :sku="item.levmoblohezp7y50"
        />
      </ul>
    </section>
  </div>
</template>

<script>
import GoodsItem from "../../components/GoodsItem";
import { online } from "@/api/platform";
const {
  buildPersonnelRecordQuery,
  getHospitalId,
  buildHospitalNoticeQuery,
} = require("@/util/personnelRecordQuery");

export default {
  name: "MallIndex",
  components: {
    GoodsItem,
  },
  data () {
    return {
      typeList: [],
      goodsList: [],
      bannerList: [],
      bannerLoading: true,
      form_head_uuid: "b39c66e39ef54c5ba5925f692af96e69",
      hierarchyList: [],
      noticeBar: [],
    };
  },
  computed: {
    displayNotice () {
      if (
        this.noticeBar &&
        this.noticeBar.length > 0 &&
        this.noticeBar[0]["7mhpyoswctp8w2ko"]
      ) {
        return this.noticeBar[0]["7mhpyoswctp8w2ko"];
      }
      return "欢迎访问杭州科普特电子·企业数字化采购平台！官方正品行货直供，支持13%增值税专票随货同行，协议客户全免邮专线直达。";
    },
  },
  async mounted () {
    const { clientToken } = this.$store.state;
    if (clientToken) {
      await this.banner();
      await this.getNoticeBar();
      await this.getHierarchyList();
      await this.getRecommendedProducts();
    } else {
      this.$router.push('/login');
    }
  },
  methods: {
    async getHierarchyList () {
      const { result } = await online({
        form_head_uuid: '850556846c4643ebbd8c24741481c3e0',
      });
      this.hierarchyList = result;
    },
    navTo (route) {
      this.$router.push(route);
    },
    selectType (typeId) {
      if (typeId === -1) return;
      this.navTo("/mall/show/goodsList/" + typeId + "/all");
    },
    async getNoticeBar () {
      try {
        const user = localStorage.getItem("user")
          ? JSON.parse(localStorage.getItem("user"))
          : {};
        if (!user.id) {
          this.noticeBar = [];
          return;
        }

        const { result: personnelRecords } = await online(
          buildPersonnelRecordQuery(user.id)
        );
        const hospitalId = getHospitalId(personnelRecords);
        if (!hospitalId) {
          this.noticeBar = [];
          return;
        }

        const { result } = await online(buildHospitalNoticeQuery(hospitalId));
        this.noticeBar = result;
      } catch (error) {
        console.error("Failed to query hospital notices:", error);
        this.noticeBar = [];
      }
    },
    // 获取banner图
    async banner () {
      this.bannerLoading = true;
      try {
        const { result } = await online({
          page: 1,
          limit: 20,
          form_head_uuid: "12b59f8a4698486784979d7416071d3e",
        });
        if (result && result.length > 0) {
          this.bannerList = result
            .map((el) => el["8dzgbn9fg4vlyagl"] && el["8dzgbn9fg4vlyagl"][0])
            .filter(Boolean);
        }
      } catch (e) {
        this.bannerList = [];
      } finally {
        this.bannerLoading = false;
      }
    },
    // 推荐商品
    async getRecommendedProducts () {
      try {
        const { form_head_uuid } = this;
        const { result } = await online({
          page: 1,
          limit: 20,
          keyword: "",
          select_option: "",
          form_head_uuid,
        });
        this.goodsList = result || [];
      } catch (e) {
        this.goodsList = [];
      }
    },
  },
};
</script>

<style scoped lang="less">
@import '../../assets/css/var.less';

.MallIndex {
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 20px;

  // 1. 首屏 Hero / Banner
  .hero-banner-section {
    width: 100%;
    height: 440px;
    overflow: hidden;
    border-radius: 16px;

    // 骨架屏加载态 (精准 440px 预占，微弱白光流动，彻底消除假文案闪现)
    .banner-skeleton {
      position: relative;
      width: 100%;
      height: 440px;
      border-radius: 16px;
      overflow: hidden;
      background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
      border: 1px solid #e2e8f0;
      box-sizing: border-box;
      padding: 0 48px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      gap: 16px;

      .skeleton-shimmer {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: linear-gradient(
          90deg,
          rgba(255, 255, 255, 0) 0%,
          rgba(255, 255, 255, 0.6) 50%,
          rgba(255, 255, 255, 0) 100%
        );
        transform: translateX(-100%);
        animation: shimmerMove 1.6s infinite ease-in-out;
        pointer-events: none;
      }

      .skeleton-badges {
        .skeleton-badge-pill {
          display: inline-block;
          width: 180px;
          height: 24px;
          border-radius: 12px;
          background-color: #cbd5e1;
        }
      }

      .skeleton-text-lines {
        display: flex;
        flex-direction: column;
        gap: 12px;

        .skeleton-line {
          border-radius: 6px;
          background-color: #cbd5e1;

          &.title {
            width: 380px;
            height: 36px;
          }

          &.desc {
            width: 520px;
            height: 18px;
          }
        }
      }
    }

    .carousel-container {
      width: 100%;
      height: 440px;
      border-radius: 16px;
      overflow: hidden;
      box-shadow: 0 4px 20px rgba(0, 60, 144, 0.06);
      border: 1px solid @brandBorder;

      .banner-img {
        width: 100%;
        height: 100%;
        object-fit: cover;
      }
    }

    // 淡入动效
    .fade-in {
      animation: bannerFadeIn 0.35s ease-out forwards;
    }

    // 兜底深蓝企业卡片 (高度与轮播图 440px 严格对齐，垂直居中排布，避免任何 DOM 抖动)
    .hero-default-card {
      position: relative;
      width: 100%;
      height: 440px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      border-radius: 16px;
      overflow: hidden;
      background: linear-gradient(135deg, #091e3a 0%, #0a2e63 50%, #003c90 100%);
      color: #ffffff;
      padding: 0 48px;
      box-sizing: border-box;
      box-shadow: 0 4px 20px rgba(0, 60, 144, 0.1);
      border: 1px solid rgba(255, 255, 255, 0.1);

      .hero-pattern-overlay {
        position: absolute;
        inset: 0;
        opacity: 0.12;
        background-image: radial-gradient(#3b82f6 1px, transparent 1px);
        background-size: 24px 24px;
        pointer-events: none;
      }

      .hero-glow-sphere {
        position: absolute;
        right: -60px;
        bottom: -60px;
        width: 320px;
        height: 320px;
        border-radius: 50%;
        background-color: rgba(59, 130, 246, 0.15);
        filter: blur(60px);
        pointer-events: none;
      }

      .hero-content {
        position: relative;
        z-index: 2;
        max-width: 680px;

        .hero-badge {
          display: inline-flex;
          align-items: center;
          gap: 8px;
          padding: 4px 12px;
          border-radius: 9999px;
          background: rgba(255, 255, 255, 0.12);
          border: 1px solid rgba(255, 255, 255, 0.18);
          font-size: 12px;
          color: #bfdbfe;
          font-weight: 500;
          margin-bottom: 16px;

          .badge-dot {
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: #60a5fa;
          }
        }

        .hero-heading {
          font-size: 32px;
          font-weight: 700;
          letter-spacing: -0.02em;
          line-height: 1.25;
          margin: 0 0 12px;
          color: #ffffff;
        }

        .hero-subtext {
          font-size: 14px;
          color: #cbd5e1;
          font-weight: 300;
          line-height: 1.6;
          margin: 0 0 24px;
        }

        .hero-actions {
          display: flex;
          align-items: center;
          gap: 12px;
          flex-wrap: wrap;

          .hero-btn {
            display: inline-flex;
            align-items: center;
            gap: 8px;
            padding: 10px 20px;
            border-radius: 10px;
            font-size: 13px;
            font-weight: 500;
            cursor: pointer;
            transition: all 0.15s ease;

            &.primary {
              background-color: #ffffff;
              color: @brandPrimary;
              border: none;
              font-weight: 600;

              &:hover {
                background-color: #eff6ff;
                transform: translateY(-1px);
              }
            }

            &.outline {
              background: rgba(255, 255, 255, 0.1);
              color: #ffffff;
              border: 1px solid rgba(255, 255, 255, 0.2);

              &:hover {
                background: rgba(255, 255, 255, 0.18);
              }
            }
          }
        }
      }
    }
  }

  // 2. 机构公告栏 (常驻微蓝条)
  .notice-bar-container {
    width: 100%;

    .notice-inner {
      display: flex;
      align-items: center;
      gap: 12px;
      padding: 10px 16px;
      background-color: #ffffff;
      border: 1px solid rgba(15, 82, 186, 0.18);
      border-left: 4px solid @brandContainer;
      border-radius: 8px;
      box-shadow: @brandShadowSm;

      .notice-tag {
        display: flex;
        align-items: center;
        gap: 6px;
        font-size: 12px;
        font-weight: 600;
        color: @brandContainer;
        flex-shrink: 0;

        .bell-icon {
          font-size: 14px;
        }
      }

      .notice-content {
        font-size: 13px;
        color: @brandTextBase;
        line-height: 1.4;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }

  // 3. 热门采购推荐专区
  .product-showcase-section {
    display: flex;
    flex-direction: column;
    gap: 16px;

    .section-header-bar {
      display: flex;
      align-items: center;
      justify-content: space-between;

      .title-left {
        display: flex;
        align-items: center;
        gap: 10px;

        .title-accent-bar {
          width: 4px;
          height: 18px;
          border-radius: 9999px;
          background-color: @brandContainer;
        }

        .section-title {
          font-size: 18px;
          font-weight: 700;
          color: @brandTextDark;
          letter-spacing: -0.01em;
          margin: 0;
          line-height: 1;
        }

        .section-subtitle {
          font-size: 13px;
          color: @brandTextMuted;
          margin-left: 4px;
        }
      }

      .view-all-link {
        display: inline-flex;
        align-items: center;
        gap: 4px;
        font-size: 13px;
        font-weight: 500;
        color: @brandContainer;
        cursor: pointer;
        transition: all 0.15s ease;

        &:hover {
          color: @brandPrimary;
          transform: translateX(2px);
        }
      }
    }

    // 5 列商品卡片矩阵
    .goods-grid {
      display: grid;
      grid-template-columns: repeat(5, 1fr);
      gap: 16px;
      list-style: none;
      padding: 0;
      margin: 0;

      @media (max-width: 1200px) {
        grid-template-columns: repeat(4, 1fr);
      }
      @media (max-width: 992px) {
        grid-template-columns: repeat(3, 1fr);
      }
      @media (max-width: 768px) {
        grid-template-columns: repeat(2, 1fr);
      }
    }
  }
}

@keyframes shimmerMove {
  100% {
    transform: translateX(100%);
  }
}

@keyframes bannerFadeIn {
  from {
    opacity: 0;
    transform: scale(0.995);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/client/MallIndex.vue